import { render, staticRenderFns } from "./DashboardEvent.vue?vue&type=template&id=6d280ef8&"
import script from "./DashboardEvent.vue?vue&type=script&lang=js&"
export * from "./DashboardEvent.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports